module.exports = __webpack_public_path__ + "img/question-mark.2907eca3.svg";